.main {
  @apply w-full inline-flex flex-col items-start justify-between gap-2.5 px-5 py-5 rounded-2xl bg-no-repeat bg-primary bg-cover aspect-[2] border border-solid border-white self-stretch;
}

.main.bg1 {
  background-image: var(--background-card-url);
}

.main.bg2 {
  background-image: var(--background-card-url-2);
}

.main.bg3 {
  background-image: var(--background-card-url-3);
}

.main.bg4 {
  background-image: var(--background-card-url-4);
}

.main.bg5 {
  background-image: var(--background-card-url-5);
}

.main.bg6 {
  background-image: var(--background-card-url-6);
}

.main.bg7 {
  background-image: var(--background-card-url-7);
}

.main.bg8 {
  background-image: var(--background-card-url-8);
}
